import React from 'react'
import PropTypes from 'prop-types'
import { hooks } from '@adc/ui-core'
import { BASE_DASHBOARD_PATH } from '../constants'
import NudgeTooltip from './nudgeTooltip'
import { nudgeKeys } from '..'

const PreferencesNudge = ({
  children,
  closeNudge,
  elmId = 'preferences',
  fade = false,
}) => {
  const isMobile = hooks.useIsMobileHook()
  const handleClose = () => {
    closeNudge(nudgeKeys.INVESTOR_PREFERENCES)
  }
  const handleSuccess = () => {
    window.location.assign(`${BASE_DASHBOARD_PATH}/preferences/`)
  }
  return (
    <NudgeTooltip
      fade={fade}
      elmId={elmId}
      children={children}
      showTooltip={!isMobile}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
      content="We'll send you properties that are relevant to you"
      header='Set your Buying Criteria'
    />
  )
}

PreferencesNudge.propTypes = {
  children: PropTypes.node.isRequired,
  closeNudge: PropTypes.func,
  elmId: PropTypes.string,
  fade: PropTypes.bool,
}

export default PreferencesNudge
